var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKeepYourNum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.5 1)",
    stroke: "#10ACE3",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    strokeWidth: 1.5,
    fill: "#F9F9F9",
    fillRule: "nonzero",
    width: 76,
    height: 76,
    rx: 38
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.76 26.332-4.428 4.428a1.137 1.137 0 0 0-.332.802V47.36A2.64 2.64 0 0 0 20.642 50h34.716A2.641 2.641 0 0 0 58 47.36V28.64A2.64 2.64 0 0 0 55.358 26H23.566a1.14 1.14 0 0 0-.806.332z",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.23 31v13.846h-8.57c-1.001 0-1.814-.808-1.814-1.808v-1.042h6.331V31h4.054z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.846 36.568v-.752h4.616-4.616zM35.846 40.03v-.752h4.616-4.616zM35.846 33.308c0-1.274.881-2.308 1.97-2.308h2.646-2.646c-1.089 0-1.97 1.034-1.97 2.308zM53.154 43.692c0 1.277-.942 2.308-2.1 2.308h-2.516 2.516c1.158 0 2.1-1.031 2.1-2.308zM53.154 40.432v.752h-4.616 4.616zM53.154 36.568v-.752h-4.616 4.616zM53.154 33.308c0-1.274-.942-2.308-2.1-2.308h-2.516 2.516c1.158 0 2.1 1.034 2.1 2.308z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepYourNum);
export default __webpack_public_path__ + "static/media/keep-your-num.afed84982e33bd77c01fcdef9775627a.svg";
export { ForwardRef as ReactComponent };